export const elapsedToMultiplier = (elapsedInMilliseconds: number) => {
  return Math.pow(Math.E, 6e-5 * elapsedInMilliseconds)
}

export const multiplierToDuration = (multiplier: number): number => {
  const r = Math.log(multiplier) / 6e-5
  return r
}
